<template>
  <router-view />
</template>

<script>
export default {
  name: 'TicketNames'
}
</script>
